// extracted by mini-css-extract-plugin
export default {"title":"JMHZ4f"};